// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JW4E"};